import { FunctionComponent } from "react";

import CreateRegisterForm from "./registerForm";

const Register: FunctionComponent = () => {
  return <CreateRegisterForm />;
};

export default Register;
